module.exports = __webpack_public_path__ + "img/Dashboard.5c2900ca.svg";